export default "__VITE_ASSET__CB_tjcKD__"